import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequisitionService } from 'src/app/services/requisition.service';
import { Requisition } from 'src/app/models/requisition';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-requisition-single',
  templateUrl: './requisition-single.component.html',
  styleUrls: ['./requisition-single.component.css']
})
export class RequisitionSingleComponent implements OnInit {
  requisition: Requisition = new Requisition();
  actualUser:string = "";
  canDelete:boolean = false;

  loading:boolean = false;
  canAuthorize:boolean = false;

  constructor( actRoute:ActivatedRoute, private reqServ:RequisitionService, private auth:AuthService, private toastr:ToastrManager ) {
    actRoute.params.subscribe(params => {
      this.loadReq(params.id);
    });
  }

  ngOnInit() { }

  authorize() {
    this.loading = true;
    this.reqServ.authorizeRequisition(this.requisition).then(requisition => {
      this.requisition = requisition;
      this.perms(requisition);
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr("La requisición no puede ser autorizada! tal vez se haya eliminado.");
      this.loading = false;
    });
  }

  getTotal() {
    return this.requisition.lines.filter(ln => ln.status != 'Cancelado').map(ln => ln.quantity * ln.unit_price * (ln.iva*1 + 1)).reduce((act, ant) => act + ant, 0);
  }

  delete(line = 0) {
    let promise:Promise<any>
    if (line) {
      promise = this.reqServ.deleteRequisition({
        requisition_id: this.requisition.id,
        requisition_line_id: line,
      });
    } else {
      promise = this.reqServ.deleteRequisition({
        requisition_id: this.requisition.id
      });
    }

    this.loading = true;
    promise.then(resp => {
      if (resp.destroyed) {
        this.toastr.successToastr("¡Elemento eliminado correctamente!");
        this.loadReq(this.requisition.id);
      } else {
        this.toastr.errorToastr("¡No puede ser eliminado!");
        this.loading = false;
      }
    });
  }

  loadReq(id) {
    this.loading = true;
    this.reqServ.getRequisition(id).then(requisition => {
      this.requisition = requisition;
      this.actualUser = `${this.requisition.user.name} ${this.requisition.user.last_name}`;
      this.loading = false;

      this.perms(requisition);
    });
  }

  perms(doc) {
    this.canDelete = this.auth.can('destroy-requisition') && !doc.authorized;
    this.canAuthorize = this.auth.can('authorize-requisition') && doc.status == 'Abierto';
  }

  pdf() {
    window.open(environment.baseUrl + '/pdf/purchases/report/requisition/' + this.requisition.id, '_blank')
  }

}
